import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { css } from '@emotion/react';
import { Text, Spacer, Button, Icon, TooltipWrapper, Colors, Link, } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { BuilderBlocks } from '@builder.io/react';
import { useTracking } from '../../tracking';
import { MEDIA_MIN_WIDTH } from '../../constants/responsive';
const Styles = labelStyles('PlanCardSection', {
    root: css({
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '15px',
        maxWidth: '1170px',
        margin: 'auto',
        padding: '0 20px',
        [MEDIA_MIN_WIDTH.small]: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
            gap: '15px',
        },
        [MEDIA_MIN_WIDTH.medium]: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
        },
        [MEDIA_MIN_WIDTH.large]: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(288px, 1fr))',
        },
        [MEDIA_MIN_WIDTH.extraLarge]: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
            gap: '20px',
        },
    }),
    plan: css({
        padding: '20px 20px 8px',
        border: `1px solid ${Colors.neutral400}`,
        borderRadius: '3px',
        transition: 'all 0.5s ease',
        '&:hover': {
            boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, 0.2)',
        },
        display: 'grid',
        gridTemplateRows: '40px minmax(100px, max-content) minmax(0, max-content) 50px minmax(30px, max-content)',
    }),
    content: css({ marginBottom: '20px' }),
    featuresText: css({
        height: '40px',
    }),
    feature: css({
        display: 'flex',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingBottom: '12px',
    }),
    tooltipWrapper: css({
        verticalAlign: 'bottom',
        marginLeft: '5px',
    }),
    secondaryCTA: css({
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        marginTop: '10px',
        fontSize: '14px',
    }),
});
export const PlanCardSection = (props) => {
    var _a;
    const { emitUserInteractionEvent } = useTracking();
    return (_jsx("div", Object.assign({ css: Styles.root }, { children: (_a = props.plans) === null || _a === void 0 ? void 0 : _a.map((plan, index) => {
            var _a, _b, _c, _d, _e, _f;
            return (_jsxs("div", Object.assign({ css: Styles.plan }, { children: [_jsx(Text, Object.assign({ color: 'neutral800', fontWeight: 700, tag: "h2", type: "sectionHeader3Bold" }, { children: plan.title })), _jsx(Text, Object.assign({ color: "neutral800", tag: "p", type: "smallPrint1" }, { children: plan.description })), _jsx("div", Object.assign({ css: Styles.content }, { children: _jsx(BuilderBlocks, { blocks: plan.content, dataPath: `component.options.plans.${index}.content`, parentElementId: props.builderBlock.id }) })), _jsx("div", { children: _jsx(Button, Object.assign({ href: (_a = plan.primaryCTA) === null || _a === void 0 ? void 0 : _a.href, isFullWidth: true, color: (_b = plan.primaryCTA) === null || _b === void 0 ? void 0 : _b.color, onClick: () => {
                                var _a, _b;
                                return emitUserInteractionEvent({
                                    event_action: 'click',
                                    interaction_name: 'call_to_action',
                                    interaction_raw_text: (_a = plan.primaryCTA) === null || _a === void 0 ? void 0 : _a.text,
                                    destination_href: (_b = plan.primaryCTA) === null || _b === void 0 ? void 0 : _b.href,
                                    option_selected: 'cta_button',
                                });
                            } }, { children: (_c = plan.primaryCTA) === null || _c === void 0 ? void 0 : _c.text })) }), _jsx("div", Object.assign({ css: Styles.secondaryCTA }, { children: _jsx(Link, Object.assign({ href: (_d = plan.secondaryCTA) === null || _d === void 0 ? void 0 : _d.href, onClick: () => {
                                var _a, _b;
                                return emitUserInteractionEvent({
                                    event_action: 'click',
                                    interaction_name: 'call_to_action',
                                    interaction_raw_text: (_a = plan.secondaryCTA) === null || _a === void 0 ? void 0 : _a.text,
                                    destination_href: (_b = plan.secondaryCTA) === null || _b === void 0 ? void 0 : _b.href,
                                    option_selected: 'cta_link',
                                });
                            } }, { children: (_e = plan.secondaryCTA) === null || _e === void 0 ? void 0 : _e.text })) })), _jsxs("div", { children: [_jsx("div", Object.assign({ css: Styles.featuresText }, { children: _jsx(Text, Object.assign({ type: "smallPrint1", fontWeight: 700, tag: "p", margin: "20px 0 10px 0" }, { children: plan.featuresText })) })), (_f = plan.features) === null || _f === void 0 ? void 0 : _f.map((feature, index) => {
                                return (_jsxs("div", Object.assign({ css: Styles.feature }, { children: [_jsx(Icon, { name: "formCheck", color: "success400", size: 16 }), _jsx(Spacer, { width: 10 }), _jsx(TooltipWrapper, Object.assign({ content: feature.tooltip, allowMultilineTooltip: true }, { children: () => (_jsxs(Fragment, { children: [feature.href ? (_jsx(Link, Object.assign({ href: feature.href }, { children: feature.text }))) : (_jsx(Text, { children: feature.text })), _jsx("span", Object.assign({ css: Styles.tooltipWrapper }, { children: _jsx(Icon, { name: "alertInfo", color: "neutral800", size: 16 }) }))] })) }))] }), `${index}-${feature.text}`));
                            })] })] }), `${plan.title}-${index}`));
        }) })));
};
//# sourceMappingURL=PlanCardSection.js.map